import { MonitoringType } from '@wix/ambassador-devcenter-apps-v1-app-old/types';
import type { MonitoringConfig } from '@wix/cli-app-definitions';

export const getMonitoringProvider = (monitoring: MonitoringConfig) => {
  if ('sentry' in monitoring) {
    return {
      type: MonitoringType.SENTRY,
      sentryOptions: monitoring.sentry,
    };
  }

  return monitoring.custom;
};
